module.exports = __webpack_public_path__ + "static/media/Star.73f2094b.png";